import { getLocalizedString } from "@icarius-localization/strings";
import {
  currencyStringToNumber,
  getLocale,
} from "./utils";

// comparators
export const numberComparatorCustom = ({ number1, number2 }, decimals) => {
  let numberString1 = currencyStringToNumber(number1, decimals);
  let numberString2 = currencyStringToNumber(number2, decimals);

  if (numberString1 === null && numberString2 === null) return 0;
  if (numberString1 === null) return -1;
  if (numberString2 === null) return 1;
  return numberString1 - numberString2;
};

export const numberComparatorMax2 = (number1, number2) => {
  let numberString1 = currencyStringToNumber(number1);
  let numberString2 = currencyStringToNumber(number2);

  if (numberString1 === null && numberString2 === null) return 0;
  if (numberString1 === null) return -1;
  if (numberString2 === null) return 1;
  return numberString1 - numberString2;
};

export const numberComparatorMax3 = (number1, number2) => {
  let numberString1 = currencyStringToNumber(number1, 3);
  let numberString2 = currencyStringToNumber(number2, 3);

  if (numberString1 === null && numberString2 === null) return 0;
  if (numberString1 === null) return -1;
  if (numberString2 === null) return 1;
  return numberString1 - numberString2;
};

export const numberComparatorMax4 = (number1, number2) => {
  let numberString1 = currencyStringToNumber(number1, 4);
  let numberString2 = currencyStringToNumber(number2, 4);

  if (numberString1 === null && numberString2 === null) return 0;
  if (numberString1 === null) return -1;
  if (numberString2 === null) return 1;
  return numberString1 - numberString2;
};

export const numberComparatorMax5 = (number1, number2) => {
  let numberString1 = currencyStringToNumber(number1, 5);
  let numberString2 = currencyStringToNumber(number2, 5);

  if (numberString1 === null && numberString2 === null) return 0;
  if (numberString1 === null) return -1;
  if (numberString2 === null) return 1;
  return numberString1 - numberString2;
};

// formatters
export const formatNumberWithAggridLocale = (value, minDecimal, maxDecimal) => {
  return new Intl.NumberFormat(getLocale(), {
    minimumFractionDigits: minDecimal,
    maximumFractionDigits: maxDecimal,
  }).format(value);
}
export const createNumberFormatter = (minDecimal, maxDecimal, allowsEmptyString = false) => {
  return ({ value }) => {
    if (typeof value === "undefined") return allowsEmptyString ? "" : undefined;
    if (value === "-") return allowsEmptyString ? "" : undefined;
    if (value === null) return allowsEmptyString ? "" : undefined;
    if (allowsEmptyString && value === "") return "";

    return formatNumberWithAggridLocale(value, minDecimal, maxDecimal);
  };
};

export const numberFormatterDecimalsCustom = ({ value }, decimals, allowsEmptyString = false) => {
  if (typeof value === "undefined") return allowsEmptyString ? "" : undefined;
  if (value === "-") return allowsEmptyString ? "" : undefined;
  if (value === null) return allowsEmptyString ? "" : undefined;
  if (allowsEmptyString && value === "") return "";

  return formatNumberWithAggridLocale(value, decimals, decimals);
};

// filterParams
export const numberFilterParams = () => ({ // como función para que las traducciones se ejecuten al momento de generar las columnas y no ni bien arranca react
  filterOptions: [
    {
      displayKey: "iguales",
      displayName: getLocalizedString("equal"),
      test: function (filterValue, cellValue) {
        let cellValueNumber = currencyStringToNumber(cellValue);
        let filterValueNumber = currencyStringToNumber(filterValue);

        if (cellValueNumber !== null && cellValueNumber !== undefined && filterValueNumber !== null && filterValueNumber !== undefined) {
          return cellValueNumber === filterValueNumber;
        }
        return false;
      },
    },
    {
      displayKey: "desiguales",
      displayName: getLocalizedString("notEqual"),
      test: function (filterValue, cellValue) {
        let cellValueNumber = currencyStringToNumber(cellValue);
        let filterValueNumber = currencyStringToNumber(filterValue);

        if (cellValueNumber !== null && cellValueNumber !== undefined && filterValueNumber !== null && filterValueNumber !== undefined) {
          return cellValueNumber !== filterValueNumber;
        }
        return false;
      },
    },
    {
      displayKey: "mayorQ",
      displayName: "Mayor",
      test: function (filterValue, cellValue) {
        let cellValueNumber = currencyStringToNumber(cellValue);
        let filterValueNumber = currencyStringToNumber(filterValue);

        if (cellValueNumber !== null && cellValueNumber !== undefined && filterValueNumber !== null && filterValueNumber !== undefined) {
          return cellValueNumber > filterValueNumber;
        }
        return false;
      },
    },
    {
      displayKey: "menorQ",
      displayName: "Menor",
      test: function (filterValue, cellValue) {
        let cellValueNumber = currencyStringToNumber(cellValue);
        let filterValueNumber = currencyStringToNumber(filterValue);

        if (cellValueNumber !== null && cellValueNumber !== undefined && filterValueNumber !== null && filterValueNumber !== undefined) {
          return cellValueNumber < filterValueNumber;
        }
        return false;
      },
    },
    {
      displayKey: "mayorQue",
      displayName: getLocalizedString("moreOrEqualThan"),
      test: function (filterValue, cellValue) {
        let cellValueNumber = currencyStringToNumber(cellValue);
        let filterValueNumber = currencyStringToNumber(filterValue);

        if (cellValueNumber !== null && cellValueNumber !== undefined && filterValueNumber !== null && filterValueNumber !== undefined) {
          return cellValueNumber >= filterValueNumber;
        }
        return false;
      },
    },
    {
      displayKey: "menorQue",
      displayName: getLocalizedString("lessOrEqualThan"),
      test: function (filterValue, cellValue) {
        let cellValueNumber = currencyStringToNumber(cellValue);
        let filterValueNumber = currencyStringToNumber(filterValue);

        if (cellValueNumber !== null && cellValueNumber !== undefined && filterValueNumber !== null && filterValueNumber !== undefined) {
          return cellValueNumber <= filterValueNumber;
        }
        return false;
      },
    },
  ],
});

export const numberFilterParamsCustom = (decimals) => {
  return {
    filterOptions: [
      {
        displayKey: "iguales",
        displayName: getLocalizedString("equal"),
        test: function (filterValue, cellValue) {
          let cellValueNumber = currencyStringToNumber(cellValue, decimals);
          let filterValueNumber = currencyStringToNumber(filterValue, decimals);

          if (cellValueNumber !== null && cellValueNumber !== undefined && filterValueNumber !== null && filterValueNumber !== undefined) {
            return cellValueNumber === filterValueNumber;
          }
          return false;
        },
      },
      {
        displayKey: "desiguales",
        displayName: getLocalizedString("notEqual"),
        test: function (filterValue, cellValue) {
          let cellValueNumber = currencyStringToNumber(cellValue, decimals);
          let filterValueNumber = currencyStringToNumber(filterValue, decimals);

          if (cellValueNumber !== null && cellValueNumber !== undefined && filterValueNumber !== null && filterValueNumber !== undefined) {
            return cellValueNumber !== filterValueNumber;
          }
          return false;
        },
      },
      {
        displayKey: "mayorQ",
        displayName: "Mayor",
        test: function (filterValue, cellValue) {
          let cellValueNumber = currencyStringToNumber(cellValue, decimals);
          let filterValueNumber = currencyStringToNumber(filterValue, decimals);

          if (cellValueNumber !== null && cellValueNumber !== undefined && filterValueNumber !== null && filterValueNumber !== undefined) {
            return cellValueNumber > filterValueNumber;
          }
          return false;
        },
      },
      {
        displayKey: "menorQ",
        displayName: "Menor",
        test: function (filterValue, cellValue) {
          let cellValueNumber = currencyStringToNumber(cellValue, decimals);
          let filterValueNumber = currencyStringToNumber(filterValue, decimals);

          if (cellValueNumber !== null && cellValueNumber !== undefined && filterValueNumber !== null && filterValueNumber !== undefined) {
            return cellValueNumber < filterValueNumber;
          }
          return false;
        },
      },
      {
        displayKey: "mayorQue",
        displayName: getLocalizedString("moreOrEqualThan"),
        test: function (filterValue, cellValue) {
          let cellValueNumber = currencyStringToNumber(cellValue, decimals);
          let filterValueNumber = currencyStringToNumber(filterValue, decimals);

          if (cellValueNumber !== null && cellValueNumber !== undefined && filterValueNumber !== null && filterValueNumber !== undefined) {
            return cellValueNumber >= filterValueNumber;
          }
          return false;
        },
      },
      {
        displayKey: "menorQue",
        displayName: getLocalizedString("lessOrEqualThan"),
        test: function (filterValue, cellValue) {
          let cellValueNumber = currencyStringToNumber(cellValue, decimals);
          let filterValueNumber = currencyStringToNumber(filterValue, decimals);

          if (cellValueNumber !== null && cellValueNumber !== undefined && filterValueNumber !== null && filterValueNumber !== undefined) {
            return cellValueNumber <= filterValueNumber;
          }
          return false;
        },
      },
    ],
  }
};

export const numberFilterParamsWithThreeDigits = () => ({ // como función para que las traducciones se ejecuten al momento de generar las columnas y no ni bien arranca react
  filterOptions: [
    {
      displayKey: "iguales",
      displayName: getLocalizedString("equal"),
      test: function (filterValue, cellValue) {
        let cellValueNumber = currencyStringToNumber(cellValue, 3);
        let filterValueNumber = currencyStringToNumber(filterValue, 3);

        if (cellValueNumber !== null && cellValueNumber !== undefined && filterValueNumber !== null && filterValueNumber !== undefined) {
          return cellValueNumber === filterValueNumber;
        }
        return false;
      },
    },
    {
      displayKey: "desiguales",
      displayName: getLocalizedString("notEqual"),
      test: function (filterValue, cellValue) {
        let cellValueNumber = currencyStringToNumber(cellValue, 3);
        let filterValueNumber = currencyStringToNumber(filterValue, 3);

        if (cellValueNumber !== null && cellValueNumber !== undefined && filterValueNumber !== null && filterValueNumber !== undefined) {
          return cellValueNumber !== filterValueNumber;
        }
        return false;
      },
    },
    {
      displayKey: "mayorQ",
      displayName: "Mayor",
      test: function (filterValue, cellValue) {
        let cellValueNumber = currencyStringToNumber(cellValue, 3);
        let filterValueNumber = currencyStringToNumber(filterValue, 3);

        if (cellValueNumber !== null && cellValueNumber !== undefined && filterValueNumber !== null && filterValueNumber !== undefined) {
          return cellValueNumber > filterValueNumber;
        }
        return false;
      },
    },
    {
      displayKey: "menorQ",
      displayName: "Menor",
      test: function (filterValue, cellValue) {
        let cellValueNumber = currencyStringToNumber(cellValue, 3);
        let filterValueNumber = currencyStringToNumber(filterValue, 3);

        if (cellValueNumber !== null && cellValueNumber !== undefined && filterValueNumber !== null && filterValueNumber !== undefined) {
          return cellValueNumber < filterValueNumber;
        }
        return false;
      },
    },
    {
      displayKey: "mayorQue",
      displayName: getLocalizedString("moreOrEqualThan"),
      test: function (filterValue, cellValue) {
        let cellValueNumber = currencyStringToNumber(cellValue, 3);
        let filterValueNumber = currencyStringToNumber(filterValue, 3);

        if (cellValueNumber !== null && cellValueNumber !== undefined && filterValueNumber !== null && filterValueNumber !== undefined) {
          return cellValueNumber >= filterValueNumber;
        }
        return false;
      },
    },
    {
      displayKey: "menorQue",
      displayName: getLocalizedString("lessOrEqualThan"),
      test: function (filterValue, cellValue) {
        let cellValueNumber = currencyStringToNumber(cellValue, 3);
        let filterValueNumber = currencyStringToNumber(filterValue, 3);

        if (cellValueNumber !== null && cellValueNumber !== undefined && filterValueNumber !== null && filterValueNumber !== undefined) {
          return cellValueNumber <= filterValueNumber;
        }
        return false;
      },
    },
  ],
});